define('usuario-minha-conta-controller',['usuario-minha-conta-resource'], function() {

  var app = angular.module('usuario.minha.conta.controller', [
      'usuario.minha.conta.resource'
  ]);

  app.controller('UsuarioMinhaContaControllerIndex', ['$scope', '$rootScope', 'UsuarioMinhaConta',  function($scope, $rootScope, UsuarioMinhaConta) {
      $scope.getInfo = function(){
          UsuarioMinhaConta.getInfo().then(function(result){
             $scope.usuario = result.usuario;
              $scope.PessoaFisica = result.PessoaFisica;
              console.log('RESULT');
              console.log(result);
           });
        }
        $scope.usuario = usuario;
        if($scope.usuario.PessoaCompletoView && $scope.usuario.PessoaCompletoView.pes_datanacimento){
            $scope.usuario.PessoaCompletoView.pes_datanacimento = new Date($scope.usuario.PessoaCompletoView.pes_datanacimento);
        }
        //$scope.getInfo();
        $scope.msgSucess = '';
        $scope.msgError = '';
        $scope.edtSenha = false;
        $scope.changeEdtSenha = function(vl){
          $scope.edtSenha = vl;
        }


      function cpf(cpf){
          cpf = cpf.replace(/\D/g, '');
          if(cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
          var result = true;
          [9,10].forEach(function(j){
              var soma = 0, r;
              cpf.split(/(?=)/).splice(0,j).forEach(function(e, i){
                  soma += parseInt(e) * ((j+2)-(i+1));
              });
              r = soma % 11;
              r = (r <2)?0:11-r;
              if(r != cpf.substring(j, j+1)) result = false;
          });
          return result;
      }

        $scope.alterarMinhaConta = function(usuarioForm){

            if($scope.usuario.PessoaView == null) {
                var obj = {
                    usu_codigo: $scope.usuario.usu_codigo,
                    lead_nome: $scope.usuario.Lead.lead_nome,
                    lead_fone: $scope.usuario.Lead.lead_fone,
                    lead_codigo: $scope.usuario.Lead.lead_codigo,
                    usu_senha:$scope.usuario.usu_senha,
                    tipo: 'lead'
                }
            }else{
                var obj = {
                    usu_codigo: $scope.usuario.usu_codigo,
                    pes_nome: $scope.usuario.PessoaView.pes_nome,
                    pes_codigo:$scope.usuario.PessoaView.pes_codigo,
                    pesf_telefone: $scope.usuario.PessoaView.pesf_telefone,
                    pesf_codigo: $scope.usuario.PessoaView.pesf_codigo,
                    pes_tipopessoa:$scope.usuario.PessoaView.pes_tipopessoa,
                    pes_cpf:$scope.usuario.PessoaCompletoView.cpfcnpj,
                    pes_datanacimento: $scope.usuario.PessoaCompletoView.pes_datanacimento,
                    usu_senha:$scope.usuario.usu_senha,
                    tipo: 'pessoa'
                }
            }
            UsuarioMinhaConta.updateUsuario(obj).then(function(result){
                if(result.success){
                    $scope.msgSucess = 'Usuário alterado com sucesso!';
                    $scope.msgError = '';
                    $rootScope.reloadUsuarioLogado();
                    usuarioForm.$setPristine();
                }else{
                    $scope.msgSucess = '';
                    $scope.msgError = 'Ocorreu um erro.';
                    if(result.errorMsg){
                        $scope.msgError = result.errorMsg;
                    }

                }
            });
        }
  }]);

});

